import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=1d3355f0&scoped=true&"
import script from "./branch.vue?vue&type=script&lang=js&"
export * from "./branch.vue?vue&type=script&lang=js&"
import style0 from "./branch.vue?vue&type=style&index=0&id=1d3355f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3355f0",
  null
  
)

export default component.exports